export enum E_LocalStorageKey {
  campusHomeShowPePointsPopupDate = 'campusHomeShowPePointsPopupDate',
  activityInviteCode = 'activityInviteCode',
  activityIdForHomework = 'activityIdForHomework',
  activityPePointsStuShowExpiredPopupDate = 'activityPePointsStuShowExpiredPopupDate',
  activityPePointsStuShowExpiredPopupId = 'activityPePointsStuShowExpiredPopupId',
  activityPePointsTeaShowExpiredPopupDate = 'activityPePointsTeaShowExpiredPopupDate',
  activityPePointsStuShowMateTaskPointsTipDate = 'activityPePointsStuShowMateTaskPointsTipDate',
  activityPePointsTeaShowExpiredPopupId = 'activityPePointsTeaShowExpiredPopupId',
  // 智慧课堂学生端设备号
  intelligentClassroomStuDeviceNo = 'intelligentClassroomStuDeviceNo',
  // 山东泰山比赛活动2026阶段目标动画
  activityShandongTaishanSegPersonIdx = 'activityShandongTaishanSegPersonIdx',
  activityShandongTaishanSegClazzIdx = 'activityShandongTaishanSegClazzIdx',
  activityShandongTaishanSegSchoolIdx = 'activityShandongTaishanSegSchoolIdx',
}

export class LocalStorageUtil {
  public static getLocalStorage(key: E_LocalStorageKey) {
    if (typeof window === 'undefined') {
      return null
    }
    return localStorage.getItem(key)
  }

  public static setLocalStorage(key: E_LocalStorageKey, value: string) {
    if (typeof window === 'undefined') {
      return null
    }
    localStorage.setItem(key, value)
  }

  public static removeLocalStorage(key: E_LocalStorageKey) {
    if (typeof window === 'undefined') {
      return null
    }
    localStorage.removeItem(key)
  }
}
